/* GTC Buy 2. Gift 1. Free. — pure logic (testable in Node) + page controller (browser).
   Addresses and per-destination shipping are handled by the Qe Multiship app after this step. */
(function (root) {
  'use strict';

  var OFFER = 'buy2gift1';
  var MS_FLAG = 'aqe_ms_is_shipping';
  var MS_ROWS = 'qe_ms_rows';
  var MS_URL = '/pages/multi-address-shipping';

  function computeSummary(o) {
    var all = [o.paidPrices[0], o.paidPrices[1], o.giftPrice];
    var retail = all[0] + all[1] + all[2];
    var free = Math.min(all[0], all[1], all[2]);
    return {
      retailValue: retail,
      freeBagDiscount: free,
      coffeeTotal: retail - free,
      deliveryEach: o.deliveryGuideCents,
      deliveryCredit: Math.min(o.deliveryCreditCents || 0, o.deliveryGuideCents * 2),
      deliveryTotal: o.deliveryGuideCents * 2 - Math.min(o.deliveryCreditCents || 0, o.deliveryGuideCents * 2),
      estimatedTotal: retail - free + o.deliveryGuideCents * 2 - Math.min(o.deliveryCreditCents || 0, o.deliveryGuideCents * 2)
    };
  }

  function buildCartItems(o) {
    var base = { _offer: OFFER, _offer_ref: o.ref };
    function props(extra) { return Object.assign({}, base, extra); }
    var items = [];
    if (o.paidVariantIds[0] === o.paidVariantIds[1]) {
      items.push({ id: o.paidVariantIds[0], quantity: 2, properties: props({ _role: 'paid' }) });
    } else {
      items.push({ id: o.paidVariantIds[0], quantity: 1, properties: props({ _role: 'paid' }) });
      items.push({ id: o.paidVariantIds[1], quantity: 1, properties: props({ _role: 'paid' }) });
    }
    items.push({
      id: o.giftVariantId,
      quantity: 1,
      properties: props({ _role: 'gift', _permission_confirmed: 'yes', 'Free gift': 'Sent separately' })
    });
    return items;
  }

  function cartConflict(cart, eligibleIds) {
    var items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      if (it.properties && it.properties._offer === OFFER) return 'offer';
      if (it.selling_plan_allocation) return 'subscription';
      if (eligibleIds.indexOf(it.variant_id) !== -1) return 'eligible';
    }
    return null;
  }

  function handOff(storage) {
    try {
      storage.removeItem(MS_ROWS);
      storage.setItem(MS_FLAG, 'true');
      return true;
    } catch (e) { return false; }
  }

  var lib = {
    OFFER: OFFER, MS_FLAG: MS_FLAG, MS_ROWS: MS_ROWS, MS_URL: MS_URL,
    computeSummary: computeSummary, buildCartItems: buildCartItems,
    cartConflict: cartConflict, handOff: handOff
  };

  if (typeof module !== 'undefined' && module.exports) module.exports = lib;
  root.GtcGiftLib = lib;
  if (typeof document === 'undefined') return;

  function init(section) {
    var dataEl = section.querySelector('[data-gg-data]');
    var form = section.querySelector('[data-gg-form]');
    if (!dataEl || !form) return;
    var data = JSON.parse(dataEl.textContent);
    var money = new Intl.NumberFormat('en-AU', { style: 'currency', currency: data.currency });
    function fmt(c) { return money.format(c / 100); }
    var byVariant = {};
    data.products.forEach(function (p) { byVariant[p.variantId] = p; });
    var eligibleIds = data.products.map(function (p) { return p.variantId; });
    var submit = form.querySelector('[data-gg-submit]');
    var errBox = section.querySelector('[data-gg-errors]');
    var summary = section.querySelector('[data-gg-summary]');

    function chosen(name) {
      var el = form.querySelector('input[name="' + name + '"]:checked');
      return el ? byVariant[el.value] : null;
    }
    function showErrors(list) {
      errBox.innerHTML = '';
      if (!list.length) { errBox.hidden = true; return; }
      var ul = document.createElement('ul');
      list.forEach(function (m) { var li = document.createElement('li'); li.textContent = m; ul.appendChild(li); });
      errBox.appendChild(ul);
      errBox.hidden = false;
      errBox.focus();
    }
    function render() {
      var b1 = chosen('bag1'), b2 = chosen('bag2'), g = chosen('gift');
      if (!b1 || !b2 || !g) {
        summary.innerHTML = '<p>Choose your two bags and a free gift bag to see your total.</p>';
        return;
      }
      var s = computeSummary({ paidPrices: [b1.price, b2.price], giftPrice: g.price, deliveryGuideCents: data.deliveryGuideCents, deliveryCreditCents: data.deliveryCreditCents });
      summary.innerHTML =
        '<dl>' +
        '<div><dt>Your 3 bags</dt><dd>' + fmt(s.retailValue) + '</dd></div>' +
        '<div class="gg-sum__free"><dt>Free bag (the lowest-priced of the three)</dt><dd>−' + fmt(s.freeBagDiscount) + '</dd></div>' +
        '<div><dt>Delivery (both parcels)</dt><dd>' + fmt(s.deliveryTotal) + '</dd></div>' +
        '<div class="gg-sum__total"><dt>Total</dt><dd>' + fmt(s.estimatedTotal) + '</dd></div>' +
        '</dl><p class="gg-sum__note">Delivery is ' + fmt(s.deliveryEach) + ' for each address, so ' + fmt(s.deliveryTotal) + ' for both parcels' + (s.deliveryCredit > 0 ? ' after a ' + fmt(s.deliveryCredit) + ' gift delivery credit' : '') + '. ' +
        'If all three bags cost the same you pay for two; if one costs more, you pay the difference.</p>';
    }
    form.addEventListener('change', render);
    render();

    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      if (submit.disabled) return;
      var b1 = chosen('bag1'), b2 = chosen('bag2'), g = chosen('gift');
      var errs = [];
      if (!b1) errs.push('Choose your first bag.');
      if (!b2) errs.push('Choose your second bag.');
      if (!g) errs.push('Choose the gift bag.');
      if (!form.elements.permission.checked) errs.push('Please confirm you will send the gift bag to someone else and have their OK to share their delivery details.');
      if (errs.length) { showErrors(errs); return; }
      showErrors([]);
      submit.disabled = true;
      var original = submit.textContent;
      submit.textContent = 'Checking availability…';

      var handles = [b1, b2, g].map(function (p) { return p.handle; })
        .filter(function (h, i, a) { return a.indexOf(h) === i; });
      Promise.all(handles.map(function (h) { return fetch('/products/' + h + '.js').then(function (x) { return x.json(); }); }))
        .then(function (live) {
          var changed = false;
          live.forEach(function (p) {
            var v = p.variants[0], mine = byVariant[v.id];
            if (!mine) return;
            if (!v.available) { mine.available = false; changed = true; }
            if (v.price !== mine.price) { mine.price = v.price; changed = true; }
          });
          if (changed) { render(); throw new Error('Prices or availability just changed. Please review your total and try again.'); }
          return fetch('/cart.js').then(function (x) { return x.json(); });
        })
        .then(function (cart) {
          var c = cartConflict(cart, eligibleIds);
          if (c === 'offer') throw new Error('You already have a Buy 2, Gift 1 in your cart. Please check out first, then start another.');
          if (c === 'subscription') throw new Error('Subscriptions cannot be combined with this offer. Please check out your subscription separately.');
          if (c === 'eligible') throw new Error('Your cart already has 250g bags. Please check out or remove them first so the free gift applies correctly.');
          var ref = (window.crypto && crypto.randomUUID) ? crypto.randomUUID() : String(Date.now()) + Math.random().toString(16).slice(2);
          var items = buildCartItems({ paidVariantIds: [b1.variantId, b2.variantId], giftVariantId: g.variantId, ref: ref });
          return fetch('/cart/add.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: items })
          }).then(function (res) {
            return res.json().then(function (body) {
              if (!res.ok) throw new Error(body.description || body.message || 'Could not add to cart.');
              return body;
            });
          });
        })
        .then(function () {
          try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('gtc_gift_offer_add_to_cart', { path: location.pathname }); } catch (e) {}
          var ok = false;
          try { ok = handOff(window.localStorage); } catch (e) {}
          window.location.href = ok ? MS_URL : '/cart';
        })
        .catch(function (e) {
          showErrors([e.message || 'Something went wrong. Please try again.']);
          submit.disabled = false;
          submit.textContent = original;
        });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    Array.prototype.forEach.call(document.querySelectorAll('[data-gg-root]'), init);
  });
})(typeof window !== 'undefined' ? window : globalThis);
